import {getCurrentCompanyId} from '../reducers/companies';
import {createRepo} from '../services/repo';

const languagesRepo = createRepo({
  modelName: 'language',
  plural: 'languages',
  idKey: 'name',
  isGlobal: true,
  getCurrentCompanyId,
});

export const {loadLanguagesFromRepo} = languagesRepo.actionCreators;

export function loadLanguages() {
  return loadLanguagesFromRepo;
}
